module.exports = __webpack_public_path__ + "static/media/img_onboarding_header_bg1.ff3be412.png";